export const translations = {
  views: {
    viewDay: {
      'en-150': 'Day',
      'sk-SK': 'Deň'
    },
    viewMonth: {
      'en-150': 'Month',
      'sk-SK': 'Mesiac'
    },
    viewWeek: {
      'en-150': 'Week',
      'sk-SK': 'Týždeň'
    },
    viewCustom: {
      'en-150': 'Custom',
      'sk-SK': 'Vlastný'
    },
    applyViewsLabel: {
      'en-150': 'Apply view',
      'sk-SK': 'Potvrdiť zobrazenie'
    },
    dismissViewsLabel: {
      'en-150': 'Dismiss',
      'sk-SK': 'Zrušiť'
    },
    weekLabel: {
      'en-150': 'Week',
      'sk-SK': 'Týždeň'
    },
    weekSelectLabel: {
      'en-150': 'Select week',
      'sk-SK': 'Vybrať týždeň'
    },
    monthSelectLabel: {
      'en-150': 'Select month',
      'sk-SK': 'Vybrať mesiac'
    },
    fromLabel: {
      'en-150': 'Starting from',
      'sk-SK': 'Obdobie od'
    },
    toLabel: {
      'en-150': 'Ending with',
      'sk-SK': 'Obdobie do'
    },
    dateRange: {
      'en-150': 'The period between',
      'sk-SK': 'Obdobie medzi'
    },
    viewsLabel: {
      'en-150': 'View of events',
      'sk-SK': 'Zobrazenie udalostí'
    }
  }
}
